import { render, staticRenderFns } from "./SimplePatientViewer.vue?vue&type=template&id=6922417c&scoped=true&"
import script from "./SimplePatientViewer.vue?vue&type=script&lang=ts&"
export * from "./SimplePatientViewer.vue?vue&type=script&lang=ts&"
import style0 from "./SimplePatientViewer.vue?vue&type=style&index=0&id=6922417c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6922417c",
  null
  
)

export default component.exports